"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useStyles = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _FieldPreviewLabel = require("./FieldPreviewLabel");

var _types = require("../../../../../../types");

var _usePkpass2 = require("../../../usePkpass");

var _FieldPreviewValue = require("./FieldPreviewValue");

var _FieldPreviewPrimary = require("./FieldPreviewPrimary");

var _reactJss = require("react-jss");

var _getTextAlign = require("./getTextAlign");

var _Theme = require("../../../../Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _reactJss.createUseStyles)({
  field: {
    padding: function padding(_ref) {
      var theme = _ref.theme;
      return "".concat(theme.scale * 10, "px ").concat(theme.scale * 12, "px");
    },
    '&:hover': {
      cursor: function cursor(_ref2) {
        var clickable = _ref2.clickable;
        return clickable ? 'pointer' : undefined;
      },
      opacity: function opacity(_ref3) {
        var clickable = _ref3.clickable;
        return clickable ? 0.7 : undefined;
      }
    }
  }
});
exports.useStyles = useStyles;

var Field = function Field(props) {
  var fieldsType = props.fieldsType,
      fieldIndex = props.fieldIndex;

  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      pass = _usePkpass.pass,
      passStyle = _usePkpass.passStyle,
      onFieldClick = _usePkpass.onFieldClick,
      onFieldDnD = _usePkpass.onFieldDnD;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dragOver = _React$useState2[0],
      setDragOver = _React$useState2[1];

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    pass: pass,
    theme: theme,
    clickable: !!onFieldClick
  });
  var fieldsPath = "".concat(passStyle, ".").concat(fieldsType);
  var fieldPath = "".concat(fieldsPath, ".").concat(fieldIndex);
  var field = (0, _lodash.get)(pass, "".concat(fieldPath));

  var onDragLeave = function onDragLeave(event) {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(false);
  };

  var onDragOver = function onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(true);
  };

  var onDragStart = function onDragStart(event) {
    event.dataTransfer.setData('droppedFieldsType', fieldsType);
    event.dataTransfer.setData('droppedIndex', "".concat(fieldIndex));
  };

  var onDrop = function onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    var droppedIndex = Number(event.dataTransfer.getData('droppedIndex'));
    var droppedFieldsType = event.dataTransfer.getData('droppedFieldsType');
    onFieldDnD(fieldsType, fieldIndex, droppedFieldsType, droppedIndex);
    setDragOver(false);
  };

  var style = {
    fontSize: 15 * theme.scale,
    minHeight: 26 * theme.scale,
    minWidth: 20 * theme.scale,
    textAlign: props.align || (0, _getTextAlign.getTextAlign)(field.textAlignment),
    zIndex: 100
  };
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FieldPreviewLabel.FieldPreviewLabel, {
    key: "fieldPreviewLabel",
    field: field,
    fieldsType: fieldsType,
    labelColor: pass.labelColor,
    theme: theme
  }), /*#__PURE__*/React.createElement(_FieldPreviewValue.FieldPreviewValue, {
    key: "fieldPreviewValue",
    field: field,
    fieldsType: fieldsType
  }));

  if (fieldsType === _types.PkpassFieldsType.PrimaryFields) {
    content = /*#__PURE__*/React.createElement(_FieldPreviewPrimary.FieldPreviewPrimary, {
      values: field
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    key: field.key,
    draggable: !!onFieldDnD,
    onDragOver: onFieldDnD ? onDragOver : undefined,
    onDrop: onFieldDnD ? onDrop : undefined,
    onDragStart: onFieldDnD ? onDragStart : undefined,
    onDragLeave: onFieldDnD ? onDragLeave : undefined,
    className: "field ".concat(fieldsType, " ").concat(classes.field),
    style: _objectSpread(_objectSpread({}, style), dragOver ? theme.dragOver : {}),
    onClick: function onClick(event) {
      if (onFieldClick) {
        onFieldClick({
          fieldsType: fieldsType,
          field: field,
          fieldIndex: fieldIndex
        }, event);
      }
    }
  }, content);
};

Field.propTypes = {
  fieldIndex: _propTypes.default.number.isRequired,
  align: _propTypes.default.oneOf(['left', 'right'])
};
var _default = Field;
exports.default = _default;
//# sourceMappingURL=Field.js.map